var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsappWhite = function SvgWhatsappWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 51"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.878,
    height: 49.878,
    y: 0.355,
    fill: "#fff",
    rx: 24.939
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#717172",
    d: "M34.823 15.398a13 13 0 0 0-9.215-3.82c-7.208 0-13.047 5.82-13.047 13.003 0 2.273.638 4.546 1.733 6.455l-1.825 6.729 6.935-1.819c1.916 1 4.014 1.546 6.204 1.546 7.208 0 13.047-5.82 13.047-13.002-.09-3.364-1.368-6.637-3.832-9.092m-2.92 13.82c-.273.727-1.55 1.455-2.19 1.546a5.1 5.1 0 0 1-2.006-.091c-.457-.182-1.095-.364-1.825-.728-3.285-1.364-5.383-4.637-5.566-4.91-.182-.181-1.368-1.727-1.368-3.364s.82-2.364 1.094-2.727c.274-.364.64-.364.913-.364h.639c.182 0 .456-.091.73.546.273.636.912 2.273 1.003 2.363a.58.58 0 0 1 0 .546c-.091.182-.182.364-.365.546-.182.181-.365.454-.456.545-.183.182-.365.364-.183.637.183.363.822 1.363 1.825 2.273 1.278 1.09 2.281 1.454 2.646 1.636s.548.091.73-.09c.183-.183.821-.91 1.004-1.274.182-.363.456-.272.73-.181.273.09 1.916.909 2.19 1.09.364.183.547.273.638.364.091.273.091.91-.182 1.637"
  })));
};
export default SvgWhatsappWhite;